module.exports = require('./_global');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_path.js
// module id = d9XR
// module chunks = 0 1